import { render, staticRenderFns } from "./JoinCrawlForm.vue?vue&type=template&id=206847b4&lang=pug"
import script from "./JoinCrawlForm.vue?vue&type=script&lang=js"
export * from "./JoinCrawlForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports